import axiosClient from '../../configs/axios.js';




class CustomerStatementReport {
    async getCustomerStatementreport(params) {
        try {
            const response = await axiosClient.get('/reports/DeliverCollect', {
                params: {
                    start_date: params.start_date,
                    end_date: params.end_date,
                    customer_id: params.customer_id // Changed from customer_id to customerId
                }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new CustomerStatementReport(); 